import React from 'react'
import { Message, MessageProps } from './Message'

export interface MessageErrorProps extends MessageProps {}

export const MessageError: React.FC<MessageErrorProps> = ({ ...rest }) => {
  return (
    <Message
      iconProps={{
        icon: 'exclamation-circle',
        color: 'error',
      }}
      {...rest}
    />
  )
}
